import { TelemetryFormat } from "../types"
import { parseDjiBrackets } from "./dji"

export const h30t = {
    name: "h30t",
    matches: (prefix) => prefix.includes("FrameCnt") && !prefix.includes("<font"),
    parse: parseDjiBrackets,
} satisfies TelemetryFormat
